import { Box } from "@mui/material";
import { FormDateSelector } from "UI/FormDateSelector";
import { FormSelectField } from "UI/FormSelectField";
import * as FP from "utils/fp-js";

const periods = {
  Daily: "Daily",
  Weekly: "Weekly",
  Monthly: "Monthly",
  Yearly: "Yearly",
};

export const AnalyticsRangeSelector = ({
  control,
  watch,
  getValues,
  setValue,
  onSubmit,
}) => {
  const period = watch("period");

  const views = FP.match(period)
    .on(periods.Monthly, ["month", "year"])
    .on(periods.Yearly, ["year"])
    .otherwise(undefined);

  const setAllDates = () => {
    const { start, end } = getValues();

    if (start !== "" || end !== "") {
      setValue("start", "", { shouldDirty: false });
      setValue("end", "", { shouldDirty: false });
    }
    onSubmit();
  };

  return (
    <div className="flex-shrink flex flex-row flex-wrap justify-start items-center gap-2 max-w-2xl">
      <Box>
        <FormSelectField
          name="period"
          control={control}
          options={periods}
          doNotSortOptions
        />
      </Box>
      <button
        className={`bg-white border border-solid border-black rounded-md p-2 text-sm`}
        onClick={setAllDates}
      >
        All Dates
      </button>
      <div className="flex-1 text-sm text-gray-500 flex flex-row gap-1 items-center">
        from:
        <Box flex={1} sx={{ minWidth: 150, maxWidth: 300  }}>
          <FormDateSelector
            views={views}
            name="start"
            control={control}
            size="small"
            disableFuture
          />
        </Box>
      </div>
      <div className="flex-1 text-sm text-gray-500 flex flex-row gap-1 items-center">
        to:
        <Box flex={1} sx={{ minWidth: 150, maxWidth: 300 }}>
          <FormDateSelector
            views={views}
            name="end"
            control={control}
            size="small"
            disableFuture
          />
        </Box>
      </div>
    </div>
  );
};
